import { GetServerSideProps } from 'next';
import { NavBarContent } from '@/components/Navbar';
import { api, site } from '@/services/api';
import InstitutionalPage from '@/components/Institutional/InstitutionalPage';
import { FeaturedNewsApi, HeadTags } from '@/shared/types/home.types';
import { SchemaType } from '@/components/Internals/InternalSchema';
import getConcurrentPromises from '@/utils/getConcurrentPromises';
import Layout from '@/components/Layout';

interface NavBarContentData {
  data: NavBarContent;
}

interface SpeedTestProps {
  data: {
    data: {
      cabecalho: {
        titulo: string;
        descricao: string;
        capa: {
          blurhash: string;
          srcset: { [key: number]: string };
          url: string;
        };
      };
      accordion: {
        titulo: string;
        conteudo: string;
      }[];
    };
  };
  schema?: SchemaType;
  ssr: HeadTags[];
  navBarData: NavBarContent;
}

export default function SpeedTest({ data, navBarData, ssr, schema }: SpeedTestProps) {
  const { cabecalho, accordion } = data.data;

  return (
    <Layout layoutData={{ segmentacoes: [], tagsData: ssr, navBarData, schema }}>
      <InstitutionalPage
        text=""
        title="Teste de Velocidade"
        headerImg={{ url: cabecalho.capa.url, blurhash: cabecalho.capa.blurhash, srcset: cabecalho.capa.srcset }}
        breadcrumbs={[]}
        accordion={accordion}
        type="velocidade"
      />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { host } = context.req.headers;

  const mainReq = { promise: site.get<FeaturedNewsApi>(`/teste-de-velocidade/`), link: `/teste-de-velocidade/` };
  const responseMenuReq = { promise: api.get<NavBarContentData>(`/componentes/menu/`), link: `/componentes/menu/` };

  const { promiseData, data, statusCode } = await getConcurrentPromises({
    mainPromise: mainReq,
    navBarPromise: responseMenuReq,
    host,
  });

  if (data.redirect || data.notFound) return data;

  const navBarData: NavBarContentData = promiseData[responseMenuReq.link].data.data;
  const { ssr, headers, schema } = data;

  context.res.setHeader('Cache-Control', headers['Cache-control']);
  context.res.setHeader('Expires', headers.Expires);
  context.res.statusCode = statusCode;

  return {
    props: {
      data,
      navBarData,
      ssr,
      headers,
      schema,
    },
  };
};
